module.exports = __webpack_public_path__ + "img/P150T_weapon_62.ff2b51a3.png";